export const getRandColor = () => {
  const colors = ['#9C27B0', '#2196F3', '#4CAF50', '#E91E63', '#673AB7', '#00BCD4', '#FF5722'];
  return colors[Math.floor(Math.random() * colors.length)];
}
